import { PropsWithChildren } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import PageSectionContainer from '../PageSectionContainer';

const MarkdownSection = ({ content }: PropsWithChildren<any>) => {
  return (
    <PageSectionContainer className="section__markdown">
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content.body}</ReactMarkdown>
    </PageSectionContainer>
  );
};

export default MarkdownSection;
